import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { Noimage } from "../../../common/imagePath";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import JsBarcode from "jsbarcode";
import { checkUserPermission } from "../../../common/UserPermission";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";

const ReceivingReport = (props) => {
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
  let PERMISSION_EDIT = "/manage-receiving/:id";
  const token = localStorage.getItem("Token");
  let navigate = useNavigate();
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const locationId = localStorage.getItem("Location");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [receivePaymentStatus, setreceivePaymentStatus] = useState("");
  const [nemultiselect, setnemultiselect] = useState({
    ReceiveType: [],
  });
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationId)
  );
  const [showList, setShowList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemIds, setItemIds] = useState({
    ItemId: 0,
    variationId: 0,
    itemName: "",
  });
  const barcodeRefs = useRef([]);
  const [suggestions, setSuggestions] = useState([]);
  const [searchItemName, setSearchItemName] = useState("");

  console.log(showList, "checkkk");

  //table state
  const [receivingTypeID, setReceivingTypeID] = useState(0);
  const [supplierID, setSupplierID] = useState(0);
  const [supplierValue, setsupplierValue] = useState();
  const [receivingTypeValue, setreceivingTypeValue] = useState();
  const [reportChange, setReportChange] = useState(false);
  const [isPurchaseOrder, setIsPurchaseOrder] = useState(false);
  const [rectype, setRectype] = useState([
    {
      ID: Number,
      SalesType: String,
    },
  ]);

  const [recoptions, setRecOptions] = useState([
    {
      Id: Number,
      CompanyName: String,
      FirstName: String,
      LastName: String,
      Email: String,
      PhoneNumber: Number,
      Address1: String,
      City: String,
      StateProvince: String,
      Zip: Number,
      Country: String,
    },
  ]);

  const handleChangeReceivingType = (event) => {
    setreceivingTypeValue(event);
    setReceivingTypeID(event?.value);
  };

  const handelItemSearch = (value) => {
    if (value != "") {
      setSuggestions([]);
      axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${encodeURIComponent(
            value
          )}&iscategory=${0}&customerid=${0}&supplierid=${0}&locationid=${locationId}&itemsearchtype=sale&isservice=${1}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "resdata2709");
          const modifiedData = res.data.ResponseData.map((item) => ({
            ...item,
            ID: item.ItemId,
            VariationId: item.VariationId,
            Name: item.VariationName != "" ? item.VariationName : item.ItemName,
            ImageURL: item.ImageName,
            Quantity:
              item.VariationId != 0
                ? item.VariationQuantity
                : item.Itemquantity,
            Categoryfullpath: item.CategoryName,
          }));
          setSuggestions(modifiedData);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setSuggestions([]);
    }
  };

  const handleInputClick = (item) => {
    console.log(item, "itemitem");
    setSearchItemName("");
    setItemIds({
      ItemId: item.ItemId,
      variationId: item.VariationId,
      itemName: item.VariationId > 0 ? item.VariationName : item.ItemName,
    });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      handelItemSearch(searchItemName);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchItemName]);

  let receivingTypeDropdownOption = [];
  const ReceivingTypeDropdown = rectype
    .filter((u) => u.ID === 2 || u.ID === 3)
    .map((u, i) => {
      receivingTypeDropdownOption[i] = { label: u.ReceivingsType, value: u.ID };
    });

  const ITEMS_PER_PAGE = 10;

  const [totalData, setTotalData] = useState({
    TotalSum: 0,
    TaxSum: 0,
  });

  const handleChangeSupplier = (event) => {
    console.log(event);
    setsupplierValue(event);
    setSupplierID(event?.value);
  };

  const handleReportChange = (event) => {
    setReportChange(event.target.checked);
  };

  const handleIsPurchaseOrder = (event) => {
    setIsPurchaseOrder(event.target.checked);
  };

  const supplierDropDown = recoptions.map((option) => ({
    value: option.ID,
    // label: option.FirstName + " " + option.LastName,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    address: option.Address,
  }));

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue?.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  const downloadPdf = async (ReceivingId) => {
    const res = await handleShowItemsData(ReceivingId);
    console.log(res, "resresres");
    const itemsData = res.data.ResponseData || [];
    const filteredItems = itemsData.filter(
      (item) => item.ItemNumber && item.ItemNumber.trim() !== ""
    );
    console.log(itemsData, "resres");
    setCurrentPage(1);
    const pdf = new jsPDF();
    filteredItems.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.ItemNumber];
      const barcodeValue = `${item.ItemNumber}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");

      console.log(paddedBarcodeValue, barcodeValue, barcodeRef, "checkall");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
      console.log(canvas, "imgData-------------------->");
    });
    pdf.deletePage(filteredItems.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  const paramObject = useParams();

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("supplyer list", response.data.ResponseData);
        setRecOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(`${config.receivingBaseUrl}/receivings/receivingtypedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log("Receving Types", response.data.ResponseData);
        setRectype(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  // const handleShowItemsData = async(ReceivingId) => {
  //   console.log(ReceivingId,"ReceivingId")
  //  await axios
  //     .get(
  //       // `${config.reportsBaseUrl}/reports/showReceiveItemsbyid?ReceivingId=${ReceivingId}&isReceiveItem=${isReceiveItem}&itemids=${ItemIds}`,
  //       `${config.reportsBaseUrl}/reports/showreceiveitemsbyid?receiveid=${ReceivingId}&isreceiveitem=0&itemids=`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("ShowList======>", res.data.ResponseData);
  //       setShowList(res.data.ResponseData);
  //       return res;
  //     });
  // };

  const handleShowItemsData = async (ReceivingId) => {
    console.log(ReceivingId, "ReceivingId");
    return await axios
      .get(
        `${config.reportsBaseUrl}/reports/showreceiveitemsbyid?receiveid=${ReceivingId}&isreceiveitem=0&itemids=`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("ShowList======>", res.data.ResponseData);
        setShowList(res.data.ResponseData);
        return res; // Now explicitly returning the response
      });
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    setTotalData({
      TotalSum: 0,
      TaxSum: 0,
    });
    axios
      .get(
        `${
          config.receivingBaseUrl
        }/receivings/listofalldata?filtercolumnsearchtext=&pagenumber=0&pagesize=0}&filtertext=&ordercolumn=&currentorder=&startdate=${startdate}&enddate=${enddate}&receivingtypeid=${receivingTypeID}&supplierid=${supplierID}&status=0&LocationID=${locationId}&receivePaymentStatus=0&itemId=${
          itemIds.ItemId
        }&variationId=${itemIds.variationId}&isPurchaseOrder=${
          isPurchaseOrder ? 1 : 0
        } `,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData.list, "res======>");
        if (res.data.ResponseCode === "SUCCESS") {
          const Filter = res.data.ResponseData.list?.map((el) => ({
            ...el,
            Supplier: String(el.Supplier),
            Comments: String(el.Comments),
          }));

          const filteredData = res.data.ResponseData.list.filter((item) => {
            if (isPurchaseOrder) {
              return item.ReceivingTypeId == 1; // Assign ReceivingTypeId = 1 when isPurchaseOrder is true
            }
            return item.ReceivingTypeId === 2 || item.ReceivingTypeId === 3;
          });

          console.log(filteredData, "FilterredData");
          setResponseData(filteredData);
          setTotalData({
            ...totalData,
            TotalSum: filteredData.reduce(
              (sum, item) => sum + (parseFloat(item.Total) || 0),
              0
            ),
            TaxSum: filteredData.reduce(
              (sum, item) => sum + (parseFloat(item.Tax) || 0),
              0
            ),
          });
          generateBarcodes();
          setLoading(false);
        } else {
          setTotalData({
            ...totalData,
            TotalSum: 0,
            TaxSum: 0,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const columns = useMemo(() => [
    {
      header: "Receiving ID",
      accessorKey: "Posid",
      filterFn: "contains",
      Cell: ({ row }) => (
        <>
          {checkUserPermission(PERMISSION_EDIT) ? (
            <>
              <Box
                component="span"
                sx={(theme) => ({
                  borderRadius: "0.3rem",
                  color: "#343f62",
                  maxWidth: "18ch",
                  fontWeight: "700",
                  textDecoration: "underline",
                  textUnderlineOffset: "3px",
                  p: "0.3rem",
                  cursor: "pointer",
                })}
                onClick={() =>
                  // navigate(`/receiving-receipt/${row.original.Posid}`)
                  window.open(
                    `/receiving-receipt/${row.original.Posid}`,
                    "_blank"
                  )
                }
              >
                {row.original.Posid}
              </Box>
              {" | "}
            </>
          ) : null}
          <Box
            component="span"
            sx={(theme) => ({
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              fontWeight: "700",
              textDecoration: "underline",
              textUnderlineOffset: "3px",
              p: "0.3rem",
              cursor: "pointer",
            })}
            //   onClick={() => navigate(`/manage-Items/${row.original.ID}`)}
            onClick={() =>
              // navigate(`/receiving-barcode-label/${row.original.ReceivingId}`)
              window.open(
                `/receiving-barcode-label/${row.original.ReceivingId}`,
                "_blank"
              )
            }
          >
            Barcode Labels
          </Box>
          {" | "}
          <Box
            component="span"
            sx={(theme) => ({
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              fontWeight: "700",
              textDecoration: "underline",
              textUnderlineOffset: "3px",
              p: "0.3rem",
              cursor: "pointer",
            })}
            onClick={() => downloadPdf(row.original.Posid)}
          >
            Barcode Sheet
          </Box>
        </>
      ),
    },
    {
      header: "Location",
      accessorKey: "Location",
      filterFn: "contains",
    },
    {
      header: "Date",
      accessorKey: "Date",
      filterFn: "contains",
      Cell: ({ row }) => {
        const Date = moment(row.original.Date);
        if (Date.isValid()) {
          return moment(Date).format(`${dateFormate.toUpperCase()}`);
        } else {
          return "";
        }
      },
    },
    {
      header: "Items Ordered",
      accessorKey: "ItemOrdered",
      filterFn: "contains",
    },
    {
      header: "Quantity Received",
      accessorKey: "QuantityReceived",
      filterFn: "contains",
    },
    {
      header: "Received By",
      accessorKey: "CreatedBy",
      filterFn: "contains",
    },
    {
      header: "Supplied By",
      accessorKey: "Supplier",
      filterFn: "contains",
    },
    {
      header: "Sub Total",
      accessorKey: "Subtotal",
      filterFn: "contains",
      Cell: ({ row }) => {
        const Subtotal = row?.original?.Subtotal;
        if (Subtotal == "0.00" || Subtotal == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Subtotal),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total",
      accessorKey: "Total",
      filterFn: "contains",
      Cell: ({ row }) => {
        const Total = row?.original?.Total;
        if (Total == "0.00" || Total == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Total),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Tax",
      accessorKey: "Tax",
      filterFn: "contains",
      Cell: ({ row }) => {
        const Tax = row?.original?.Tax;
        if (Tax == "0.00" || Tax == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(Number(Tax), { CurrencySymbol }, FractionDigits)}
            </div>
          );
        }
      },
    },
    {
      header: "Payment Type",
      accessorKey: "PaymentType",
    },
    {
      header: "Comments",
      filterFn: "contains",
      accessorKey: "Comments",
    },
    {
      header: "Receive Type",
      accessorKey: "ReceiveType",
      filterSelectOptions: nemultiselect?.ReceiveType, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
    },
  ]);

  const renderDetailPanel = ({ row }) => (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>Item Number</TableCell>
            <TableCell>ProductID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Category</TableCell>
            <TableCell>Current Cost Price</TableCell>
            <TableCell>Quantity Received</TableCell>
            <TableCell>Subtotal</TableCell>
            <TableCell>Total</TableCell>
            <TableCell>Selling Price</TableCell>
            {checkUserPermission(PERMISSION_SHOW_COST_PRICE) && (
              <TableCell>Cost Price </TableCell>
            )}
            <TableCell>Discount</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {showList.map((row) => (
            <TableRow key={row.name}>
              <TableCell>{row.ItemNumber}</TableCell>
              <TableCell>{row.ProductId}</TableCell>
              <TableCell>{row.ItemName}</TableCell>
              <TableCell>{row.Category}</TableCell>
              {/* <TableCell>{row.CurrentCostPrice}</TableCell> */}
              <TableCell>
                {CurrencySymbols(
                  Number(row.CurrentCostPrice),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </TableCell>
              <TableCell>{row.QuantitySold}</TableCell>
              {/* <TableCell>{row.Subtotal}</TableCell> */}
              <TableCell>
                {CurrencySymbols(
                  Number(row.Subtotal),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </TableCell>
              {/* <TableCell>{row.Total}</TableCell> */}
              <TableCell>
                {CurrencySymbols(
                  Number(row.Total),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </TableCell>
              {/* <TableCell>{row.UnitPrice}</TableCell> */}
              <TableCell>
                {CurrencySymbols(
                  Number(row.UnitPrice),
                  { CurrencySymbol },
                  FractionDigits
                )}
              </TableCell>
              {checkUserPermission(PERMISSION_SHOW_COST_PRICE) && (
                // <TableCell>{row.CostPrice}</TableCell>
                <TableCell>
                  {CurrencySymbols(
                    Number(row.CostPrice),
                    { CurrencySymbol },
                    FractionDigits
                  )}
                </TableCell>
              )}
              <TableCell>{row.Discount}</TableCell>
              <TableCell>{row.Size}</TableCell>
              <TableCell>{row.Description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    // </Box>
  );
  const processedReceivingIds = new Set();

  const muiExpandButtonProps = ({ row, table }) => {
    console.log(row, table, "rowtabledata");

    const ReceivingId = row.original.Posid;

    // Check if reportChange is true; if not, disable expansion
    if (reportChange) {
      return {
        disabled: true, // Disable the expand button when reportChange is false
        style: { cursor: "not-allowed", opacity: 0.5 }, // Optional: Styling for disabled state
      };
    }

    return {
      onClick: () => {
        // Check if this ReceivingId has already been processed
        if (!processedReceivingIds.has(ReceivingId)) {
          // Call your function
          handleShowItemsData(ReceivingId);

          // Mark this ReceivingId as processed
          processedReceivingIds.add(ReceivingId);
        }

        // Set only this row to be expanded
        table.setExpanded({ [row.id]: !row.getIsExpanded() });
      },
    };
  };

  // const muiExpandButtonProps = ({ row, table }) => {
  //   console.log(row, table, "rowtabledata");

  //   const ReceivingId = row.original.Posid;
  //   return {
  //     onClick: () => {
  //       // Check if this ReceivingId has already been processed
  //       if (!processedReceivingIds.has(ReceivingId)) {
  //         // Call your function
  //         handleShowItemsData(ReceivingId);

  //         // Mark this ReceivingId as processed
  //         processedReceivingIds.add(ReceivingId);
  //       }

  //       // Set only this row to be expanded
  //       table.setExpanded({ [row.id]: !row.getIsExpanded() });
  //     },
  //   };
  // };

  // const handleListData = (
  //   pagenumber,
  //   pagesize,
  //   filtertext,
  //   ordercolumn,
  //   currentorder,
  //   startingdate,
  //   endingdate,
  //   receivingtypeid,
  //   supplierid,
  //   columnFilters,
  //   globalFilter,
  //   pagination,
  //   sorting,
  //   status
  // ) => {
  //   setLoading(true);

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
  //     return {
  //       columnname: el.id,
  //       value: el.value,
  //       id: index + 1,
  //       count: el.id === "Supplier" ? el.value.length : 0,
  //       ismultiple: el.id === "Supplier" ? 1 : 0,
  //     };
  //   });

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   // const columnIndex = columns.findIndex(
  //   //   (column) => column.accessorKey === sorting[0]?.id
  //   // );
  //   const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

  //   supplierid = supplierid > 0 ? supplierid : 0;
  //   receivingtypeid = receivingtypeid > 0 ? receivingtypeid : 0;
  //   startingdate = startingdate === undefined ? "" : startingdate;
  //   endingdate = endingdate === undefined ? "" : endingdate;

  //   axios
  //     .get(
  //       `${
  //         config.receivingBaseUrl
  //       }/receivings/listofalldata?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=0&pagesize=0}&filtertext=&ordercolumn=&currentorder=&startdate=${startingdate}&enddate=${endingdate}&receivingtypeid=${receivingtypeid}&supplierid=${supplierid}&status=${status}&LocationID=${locationId}&receivePaymentStatus=${receivePaymentStatus}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData, "res======>");
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         const Filter = res.data.ResponseData?.map((el) => ({
  //           ...el,
  //           Supplier: String(el.Supplier),
  //           Comments: String(el.Comments),
  //         }));

  //         const data = res.data.ResponseData;
  //         setnemultiselect({
  //           ReceiveType: [...new Set(data?.map((item) => item?.ReceiveType))],
  //         });

  //         setResponseData(Filter);
  //         setData(Filter);
  //         setRowCount(res.data.ResponseData[0].TotalRecord);
  //         setTotalRows(res.data.ResponseData[0]?.TotalRecord);
  //         setRowCount(res.data.ResponseData[0]?.TotalRecord);
  //         setTotalData({
  //           ...totalData,
  //           TotalSum: res.data.ResponseData[0].TotalSum,
  //           TaxSum: res.data.ResponseData[0].TaxSum,
  //         });
  //       } else {
  //         setRowCount(0);
  //         setTotalData({
  //           ...totalData,
  //           TotalSum: 0,
  //           TaxSum: 0,
  //         });
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   // if (quickBookOptions?.value !== 2) {
  //   handleListData(
  //     1,
  //     perPageSize,
  //     searchtext,
  //     sortingId,
  //     sortingDirection,
  //     startdate,
  //     enddate,
  //     receivingTypeID,
  //     supplierID,
  //     columnFilters,
  //     globalFilter,
  //     pagination,
  //     sorting
  //     // status
  //   );
  //   // }
  // }, [
  //   receivingTypeID,
  //   supplierID,
  //   // status,
  //   // quickBookOptions,
  //   columnFilters,
  //   globalFilter,
  //   pagination,
  //   sorting,
  //   startdate,
  //   enddate,
  // ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Detailed Receivings Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              {/* <div className="row"> */}
              <div className="col-md-12 z-4">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={reportdropdown}
                  // defaultValue={selectReport}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="Reportperiod"
                  id="Reportperiod"
                  value={reportdropdown.find((e) => e.value === selectReport)}
                  onChange={(event) => {
                    handleDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
              {/* </div> */}
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Supplier :
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    defaultValue={supplierValue}
                    onChange={(event) => {
                      handleChangeSupplier(event);
                    }}
                    options={supplierDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Receiving Type:
              </label>
              <div className="row">
                <div className="col-md-11 z-3">
                  <Select
                    defaultValue={receivingTypeValue}
                    onChange={(event) => {
                      handleChangeReceivingType(event);
                    }}
                    options={receivingTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <div className=" col-form-label">Items</div>
              <div>
                <input
                  type="search"
                  placeholder="Search..."
                  className="search-btn form-control form-control-sm"
                  onChange={(e) => {
                    setSearchItemName(e.target.value);
                  }}
                  value={searchItemName}
                  style={{ width: "265px" }}
                />
                {itemIds.itemName && (
                  <>
                    ({itemIds.itemName})
                    <button
                      onClick={() => {
                        setItemIds({
                          ItemId: 0,
                          variationId: 0,
                          itemName: "",
                        });
                      }}
                    >
                      <i class="fa fa-remove"></i>
                    </button>
                  </>
                )}
                {suggestions?.length > 0 ? (
                  <>
                    <div className="dropdown">
                      <ul
                        className="dropdown-menu show dropdown-suggestion"
                        style={{
                          overflow: "auto",
                          width: "max-content",
                          maxWidth: "600px",
                        }}
                      >
                        {suggestions?.map((item) => (
                          <li
                            className="border-bottom"
                            key={item.ID}
                            onClick={(e) => handleInputClick(item)}
                          >
                            <Link
                              key={item.ID}
                              href="#"
                              class="dropdown-item"
                              data-name={item.Name?.toLowerCase()}
                            >
                              <img
                                src={item.ImageURL || Noimage}
                                onError={(e) => {
                                  e.currentTarget.src = Noimage;
                                }}
                                alt={item.Name}
                                className="img-thumbnail rounded-circle mr-4"
                                width="55"
                                height="55"
                                style={{
                                  height: "60px",
                                  objectFit: "contain",
                                }}
                              />
                              <div className="customer-info w-100">
                                <strong
                                  className="word-break-data"
                                  style={{
                                    fontWeight: "bold",
                                    color: "#333",
                                  }}
                                >
                                  {item.Name}{" "}
                                  {item.Name ? `(${item.Name})` : ""}
                                </strong>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label form-label p-lg-medium">
                Show Summary Only
              </label>
              <div className="row">
                <input
                  type="checkbox"
                  className="form-check-input mr-2"
                  style={{ width: "1.50em", height: "1.50em" }}
                  onChange={(e) => handleReportChange(e)}
                  id="reportChnage"
                  name="reportChnage"
                />
              </div>
            </div>
            <div className="col-sm-2">
              <label className="col-form-label form-label p-lg-medium">
                Is Purchase Order (PO)
                <div className="row">
                  <input
                    type="checkbox"
                    className="form-check-input mr-2"
                    style={{ width: "1.50em", height: "1.50em" }}
                    onChange={(e) => handleIsPurchaseOrder(e)}
                    id="reportChnage"
                    name="reportChnage"
                  />
                </div>
              </label>
            </div>
            <div className="col">
              {/* align-self-sm-end */}
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                {""}
              </label>
 
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div
                className="row mt-3"
                style={{
                  display: "grid",
                  gap: "1rem",
                  // gridTemplateColumns: "repeat(5,1fr)"
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.TotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {CurrencySymbols(
                          Number(totalData.TaxSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Tax</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3" id="print">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center" id="header">
                      <h6 className="P">Sonar Pos</h6>
                      <p className="fw-bold p-regular">
                        Detailed Receivings Report
                      </p>
                      <div className="row">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />

                  <div>
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Detailed Receivings Report"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={[]}
                      columnsVisibility={{}}
                      renderDetailPanel={renderDetailPanel}
                      muiExpandButtonProps={muiExpandButtonProps}
                      enableRowSelection={false}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div style={{ display: "none" }}>
        {showList?.map((item) => (
          <>
            <div key={item.ReceivingId}>
              <canvas
                data-name={item.ItemNumber}
                ref={(el) => (barcodeRefs.current[item.ItemNumber] = el)}
                id={`barcode-${item.ItemNumber}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default ReceivingReport;
